
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host :is(h1, h2, h3, h4, h5, h6, h7, p){
    all:unset;
  }

:host([has-image]) .search-results--image{
    display:none;
  }

@media (min-width: 1024px){
    :host([has-image]) .container{
      display:flex;
      column-gap:var(--spacing-6);
    }
    :host([has-image]) .search-results--image{
      display:flex;
      width:100%;
      max-width:25%;
      height:auto;
    }
  }

.eyebrow,
.eyebrow :is(h1, h2, h3, h4, h5, h6, h7){
  letter-spacing:0.5px;
  font-weight:normal !important;
  font-size:var(--sic-search-teaser--default--eyebrow-font-size);
  font-size:var(
    --sic-search-teaser--eyebrow-font-size,
    var(--sic-search-teaser--default--eyebrow-font-size)
  );
}

.eyebrow-header{
  display:flex;
  justify-content:space-between;
}

.date{
  margin-top:var(--sic-search-teaser--default--spacing-m);
  margin-top:var(
    --sic-search-teaser--spacing-m,
    var(--sic-search-teaser--default--spacing-m)
  );
  font-weight:normal;
  font-size:var(--sic-search-teaser--default--eyebrow-font-size);
  font-size:var(
    --sic-search-teaser--eyebrow-font-size,
    var(--sic-search-teaser--default--eyebrow-font-size)
  );
}

.container{
  padding-bottom:var(--sic-search-teaser--default--spacing-l);
  padding-bottom:var(
    --sic-search-teaser--spacing-l,
    var(--sic-search-teaser--default--spacing-l)
  );
  color:var(--sic-search-teaser--default--text-color-default);
  color:var(
    --sic-search-teaser--text-color-default,
    var(--sic-search-teaser--default--text-color-default)
  );
}

.heading{
  margin-top:var(--sic-search-teaser--default--spacing-s);
  margin-top:var(
    --sic-search-teaser--spacing-s,
    var(--sic-search-teaser--default--spacing-s)
  );
  word-break:break-word;
  font-size:var(--sic-search-teaser--default--heading-font-size);
  font-size:var(
    --sic-search-teaser--heading-font-size,
    var(--sic-search-teaser--default--heading-font-size)
  );
}

.subHeading{
  font-weight:bold;
  color:var(--sic-search-teaser--default--text-color-default);
  color:var(
    --sic-search-teaser--text-color-default,
    var(--sic-search-teaser--default--text-color-default)
  );
  margin-top:var(--sic-search-teaser--default--spacing-s);
  margin-top:var(
    --sic-search-teaser--spacing-s,
    var(--sic-search-teaser--default--spacing-s)
  );
}

.description{
  margin-top:var(--sic-search-teaser--default--spacing-m);
  margin-top:var(
    --sic-search-teaser--spacing-m,
    var(--sic-search-teaser--default--spacing-m)
  );
  font-weight:normal;
  font-size:var(--body-01-font-size);
}

a{
  color:var(--sic-search-teaser--default--text-color-default);
  color:var(
    --sic-search-teaser--text-color-default,
    var(--sic-search-teaser--default--text-color-default)
  );
}

a:focus{
    outline:auto;
    outline-offset:2px;
  }
`;